import loadable from '@loadable/component';

export const CmsVideoBlockLoadable = loadable(() => import('./CmsVideoBlock'), {
  resolveComponent: (module) => module.CmsVideoBlock,
});
